module.exports = __webpack_public_path__ + "static/media/FashionStoreEnviro.0436b43c.jpg";